import React, { useEffect, useState } from 'react';

// Removed Modal, Switch imports
// Added CBModal, CBSwitch imports
import { CBModal } from '../../../core/components/cbd';
import { CBSwitch } from '../../../core/components/CBSwitch';


const EditActiveModal = ({
	currentActive,
	visible,
	handleOk,
	confirmLoading,
	handleCancel,
	setNewActiveState
}) => {

	const [checked, setChecked] = useState(currentActive);

	useEffect(() => {
		setChecked(currentActive);
	}, [visible]);

	return (
		// Replaced Modal with CBModal
		<CBModal
			title="Edit Active"
			visible={visible}
			onPositiveClick={handleOk} // Map onOk
			confirmLoading={confirmLoading} // Assuming CBModal supports this
			onCancelClick={handleCancel} // Map onCancel
		>
			{/* Replaced Switch with CBSwitch */}
			<div className="flex items-center space-x-2"> {/* Added wrapper for label/switch */}
				<CBSwitch
					// defaultChecked={currentActive} // CBSwitch might not need defaultChecked if controlled
					checked={checked}
					onChange={(pendingChecked) => {
						setChecked(pendingChecked);
						setNewActiveState(pendingChecked);
					}}
				/>
				<span className="text-sm">{checked ? 'Active' : 'Inactive'}</span> {/* Optional label */}
			</div>
		</CBModal>
	)
}

export default EditActiveModal
